<template>
    <div class="real_box">
        <!-- 搜索区域 -->
        <div class="search_box">
            <div class="box_line">
                <div class="line_input">
                    <div class="input_title">记录时间</div>
                    <el-date-picker size="small" v-model="searchDate" type="datetimerange"
                        value-format="yyyy-MM-dd HH:mm:ss" range-separator="至" start-placeholder="开始日期"
                        end-placeholder="结束日期" style="width: 392px;"></el-date-picker>
                </div>
                <div class="search-btn" @click="fnSearchRecord"><span>搜索</span></div>
                <div class="search-btn orange" @click="fnSearchRecord"><span>刷新</span></div>
                <div class="title">
                    <!-- 标题 -->
                    <span>预报警记录</span>
                    <!-- 关闭当前组件 -->
                    <svg-icon class="close" icon-class="close" @click="fnClose" />
                </div>
            </div>
        </div>
        <!-- 记录列表 -->
        <div class="cont_list" v-if="type == 1">
            <div class="list_title">
                <div class="title_item">pm2.5</div>
                <div class="title_item">pm2.5国控值</div>
                <div class="title_item">pm10</div>
                <div class="title_item">pm10国控值</div>
                <div class="title_item">设备状态</div>
                <div class="title_item" style="width: 160px;">记录时间</div>
            </div>
            <div class="list_boxes">
                <div class="list_box">
                    <div v-if="tableData">
                        <div class="box_line" v-for="(item, index) in tableData" :key="index">
                            <div class="list_item">{{ item.pm2p5 ? item.pm2p5 : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.pm2p5_1h ? item.pm2p5_1h : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.pm10 ? item.pm10 : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.pm10_1h ? item.pm10_1h : 0 }} μg/m³</div>
                            <div class="list_item" :title="fnEnvrionmentStatusToText(item.status).text">
                                <span v-if="fnEnvrionmentStatusToText(item.status).status != 0"
                                    style="color: #E6A23C">{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                                <span v-else>{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                            </div>
                            <div class="list_item" style="width: 160px;">{{ item.record_at ? item.record_at : '无' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="cont_list" v-else-if="type == 2">
            <div class="list_title">
                <div class="title_item">噪音</div>
                <div class="title_item">设备状态</div>
                <div class="title_item" style="width: 160px;">记录时间</div>
            </div>
            <div class="list_boxes">
                <div class="list_box">
                    <div v-if="tableData">
                        <div class="box_line" v-for="(item, index) in tableData" :key="index">
                            <div class="list_item">{{ item.noise ? item.noise : 0 }}分贝</div>
                            <div class="list_item" :title="fnEnvrionmentStatusToText(item.status).text">
                                <span v-if="fnEnvrionmentStatusToText(item.status).status != 0"
                                    style="color: #E6A23C">{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                                <span v-else>{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                            </div>
                            <div class="list_item" style="width: 160px;">{{ item.record_at ? item.record_at : '无' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="cont_list_s" v-else-if="type == 3">
            <div class="list_title">
                <div class="title_item">pm2.5</div>
                <div class="title_item">pm2.5国控值</div>
                <div class="title_item">pm10</div>
                <div class="title_item">pm10国控值</div>
                <div class="title_item">噪音</div>
                <div class="title_item">温度</div>
                <div class="title_item">湿度</div>
                <div class="title_item">气压</div>
                <div class="title_item">风力</div>
                <div class="title_item">风速</div>
                <div class="title_item">风向</div>
                <div class="title_item">悬浮颗粒物</div>
                <div class="title_item">环境光照度</div>
                <div class="title_item">太阳总辐射</div>
                <div class="title_item">小时雨量mm/hour</div>
                <div class="title_item">瞬时雨量mm/min</div>
                <div class="title_item">当日总雨量mm/day</div>
                <div class="title_item">设备状态</div>
                <div class="title_item">记录时间</div>
            </div>
            <div class="list_boxes">
                <div class="list_box">
                    <div v-if="tableData">
                        <div class="box_line" v-for="(item, index) in tableData" :key="index">
                            <div class="list_item">{{ item.pm2p5 ? item.pm2p5 : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.pm2p5_1h ? item.pm2p5_1h : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.pm10 ? item.pm10 : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.pm10_1h ? item.pm10_1h : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.noise ? item.noise : 0 }}分贝</div>
                            <div class="list_item">{{ item.temperature ? item.temperature : 0 }}℃</div>
                            <div class="list_item">{{ item.humidity ? item.humidity : 0 }}%</div>
                            <div class="list_item">{{ item.pressure ? item.pressure : 0 }}kpa</div>
                            <div class="list_item">{{ item.wind_grade ? item.wind_grade : 0 }}级</div>
                            <div class="list_item">{{ item.wind_speed ? item.wind_speed : 0 }}m/s</div>
                            <div class="list_item">
                                {{ item.wind_direction_location ? fnToggleText(item.wind_direction_location) : '' }}
                            </div>
                            <div class="list_item">{{ item.TSP ? item.TSP : 0 }}μg/m³</div>
                            <div class="list_item">{{ item.light ? item.light : 0 }}lux</div>
                            <div class="list_item">{{ item.total_solar_radiation ? item.total_solar_radiation : 0 }}W/m2
                            </div>
                            <div class="list_item">{{ item.rainfall_hour ? item.rainfall_hour : 0 }}</div>
                            <div class="list_item">{{ item.rainfall_min ? item.rainfall_min : 0 }}</div>
                            <div class="list_item">{{ item.rainfall_day ? item.rainfall_day : 0 }}</div>
                            <div class="list_item" :title="fnEnvrionmentStatusToText(item.status).text">
                                <span v-if="fnEnvrionmentStatusToText(item.status).status != 0"
                                    style="color: #E6A23C">{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                                <span v-else>{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                            </div>
                            <div class="list_item">{{ item.record_at ? item.record_at : '无' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="cont_list" v-else-if="type == 4">
            <div class="list_title">
                <div class="title_item">水质Ph</div>
                <div class="title_item">水质浊度</div>
                <div class="title_item">水质导电率</div>
                <div class="title_item">水质溶解氧</div>
                <div class="title_item">水质COD</div>
                <div class="title_item">设备状态</div>
                <div class="title_item" style="width: 160px;">记录时间</div>
            </div>
            <div class="list_boxes">
                <div class="list_box">
                    <div v-if="tableData">
                        <div class="box_line" v-for="(item, index) in tableData" :key="index">
                            <div class="list_item">{{ item.water_quality_ph ? item.water_quality_ph : 0 }}</div>
                            <div class="list_item">{{ item.water_quality_turbidity ? item.water_quality_turbidity : 0 }}
                                NTU</div>
                            <div class="list_item">{{ item.water_conductivity ? item.water_conductivity : 0 }} us/cm
                            </div>
                            <div class="list_item">{{ item.water_dissolved_oxygen ? item.water_dissolved_oxygen : 0 }}
                                mg/L</div>
                            <div class="list_item">{{ item.water_cod ? item.water_cod : 0 }}mg/L</div>
                            <div class="list_item" :title="fnEnvrionmentStatusToText(item.status).text">
                                <span v-if="fnEnvrionmentStatusToText(item.status).status != 0"
                                    style="color: #E6A23C">{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                                <span v-else>{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                            </div>
                            <div class="list_item" style="width: 160px;">{{ item.record_at ? item.record_at : '无' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="cont_list" v-else-if="type == 5">
            <div class="list_title">
                <div class="title_item" style="width: 160px;">空气质量 TVOC</div>
                <div class="title_item">设备状态</div>
                <div class="title_item" style="width: 160px;">记录时间</div>
            </div>
            <div class="list_boxes">
                <div class="list_box">
                    <div v-if="tableData">
                        <div class="box_line" v-for="(item, index) in tableData" :key="index">
                            <div class="list_item" style="width: 160px;">
                                {{ item.air_quality ? item.air_quality : 0 }}ug/m3
                            </div>
                            <div class="list_item" :title="fnEnvrionmentStatusToText(item.status).text">
                                <span v-if="fnEnvrionmentStatusToText(item.status).status != 0"
                                    style="color: #E6A23C">{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                                <span v-else>{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                            </div>
                            <div class="list_item" style="width: 160px;">{{ item.record_at ? item.record_at : '无' }}
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="cont_list" v-else>
            <div class="list_title">
                <div class="title_item">pm2.5</div>
                <div class="title_item">pm2.5国控值</div>
                <div class="title_item">pm10</div>
                <div class="title_item">pm10国控值</div>
                <div class="title_item">噪音</div>
                <div class="title_item">温度</div>
                <div class="title_item">湿度</div>
                <div class="title_item">气压</div>
                <div class="title_item">风力</div>
                <div class="title_item">风速</div>
                <div class="title_item">风向</div>
                <div class="title_item">悬浮颗粒物</div>
                <div class="title_item">设备状态</div>
                <div class="title_item">记录时间</div>
            </div>
            <div class="list_boxes">
                <div class="list_box">
                    <div v-if="tableData">
                        <div class="box_line" v-for="(item, index) in tableData" :key="index">
                            <div class="list_item">{{ item.pm2p5 ? item.pm2p5 : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.pm2p5_1h ? item.pm2p5_1h : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.pm10 ? item.pm10 : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.pm10_1h ? item.pm10_1h : 0 }} μg/m³</div>
                            <div class="list_item">{{ item.noise ? item.noise : 0 }}分贝</div>
                            <div class="list_item">{{ item.temperature ? item.temperature : 0 }}℃</div>
                            <div class="list_item">{{ item.humidity ? item.humidity : 0 }}%</div>
                            <div class="list_item">{{ item.pressure ? item.pressure : 0 }}kpa</div>
                            <div class="list_item">{{ item.wind_grade ? item.wind_grade : 0 }}级</div>
                            <div class="list_item">{{ item.wind_speed ? item.wind_speed : 0 }}m/s</div>
                            <div class="list_item">
                                {{ item.wind_direction_location ? fnToggleText(item.wind_direction_location) : '' }}
                            </div>
                            <div class="list_item">{{ item.TSP ? item.TSP : 0 }}μg/m³</div>
                            <div class="list_item" :title="fnEnvrionmentStatusToText(item.status).text">
                                <span v-if="fnEnvrionmentStatusToText(item.status).status != 0"
                                    style="color: #E6A23C">{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                                <span v-else>{{ fnEnvrionmentStatusToText(item.status).msg }}</span>
                            </div>
                            <div class="list_item">{{ item.record_at ? item.record_at : '无' }}</div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <!-- 翻页 -->
        <div class="cont_page">
            <el-pagination class="pagination" background @size-change="handleSizeChange"
                @current-change="handleCurrentChange" :page-sizes="pageSizes" :page-size="pageSize"
                layout="total, sizes, prev, pager, next, jumper" :total="pageTotal"></el-pagination>
        </div>
    </div>
</template>

<script>
    import request from '@/utils/request';
    import APP from '@/utils/base';
    export default {
        props: {
            currentEnvironment: {
                type: Object
            }
        },
        data() {
            return {
                pageSize: APP.PAGE.LIMIT,
                pageSizes: APP.PAGE.SIZE_OPTION,
                currentPage: APP.PAGE.SKIP_PAGE,
                pageTotal: 0,
                searchDate: null,
                tableData: [],
                type: 0,
                currentEnvironmentNew: {
                    eqptStatus: '',
                    number: '',
                    nowTime: ''
                }
            };
        },
        created() {
            this.fnInit();
        },
        watch: {
            currentEnvironment: {
                handler: function(newV, oldV) {
                    if (oldV && newV) {
                        if (newV.nowTime >= oldV.nowTime) {
                            this.fnInit();
                        }
                    }
                    if (newV === undefined) {
                        this.currentEnvironmentNew = {
                            eqptStatus: '',
                            number: '',
                            nowTime: ''
                        }
                        this.type = 0;
                    } else {
                        this.currentEnvironmentNew.eqptStatus = newV.eqptStatus;
                        this.currentEnvironmentNew.number = newV.number;
                        this.currentEnvironmentNew.nowTime = newV.nowTime;
                        this.fnInit();
                        this.type = newV.type;
                    }

                    this.type = this.type ? this.type : 0
                },
                immediate: true,
                deep: true
            }
        },
        methods: {
            fnToggleText(status) {
                switch (status) {
                    case 0:
                        return '北风';
                    case 1:
                        return '东北风';
                    case 2:
                        return '东风';
                    case 3:
                        return '东南风';
                    case 4:
                        return '南风';
                    case 5:
                        return '西南风';
                    case 6:
                        return '西风';
                    case 7:
                        return '西北风';
                    default:
                        return '';
                }
            },
            // 更改分页内容
            handleSizeChange(val) {
                this.pageSize = val;
                this.fnSearchRecord();
            },
            // 翻页
            handleCurrentChange(val) {
                this.currentPage = val;
                this.fnGetEnvironmentRecord({
                        number: this.currentEnvironmentNew.number,
                        is_alarm: APP.YES,
                        create_at: this.searchDate ? this.searchDate.join(',') : '',
                        page: this.currentPage,
                        size: this.pageSize
                    },
                    res => {
                        this.tableData = res.query;
                        this.pageTotal = res.count;
                    }
                );
            },
            // 初始化
            fnInit() {
                this.currentPage = APP.PAGE.SKIP_PAGE;
                this.pageSize = APP.PAGE.LIMIT;
                if (!this.currentEnvironmentNew.number) return;
                this.fnGetEnvironmentRecord({
                        number: this.currentEnvironmentNew.number,
                        is_alarm: APP.YES,
                        page: this.currentPage,
                        size: this.pageSize
                    },
                    res => {
                        this.tableData = res.query;
                        this.pageTotal = res.count;
                    }
                );
            },
            // 获取扬尘实时记录
            fnGetEnvironmentRecord(_obj, _cb) {
                request({
                        url: 'environmental/getRecord',
                        method: 'GET',
                        params: _obj
                    })
                    .then(res => {
                        _cb && _cb(res.data);
                    })
                    .catch(err => {
                        this.tableData = [];
                        this.pageTotal = 0;
                        // this.$message.error(err.data)
                    });
            },
            // 搜索扬尘实时记录
            fnSearchRecord() {
                this.currentPage = APP.PAGE.SKIP_PAGE;
                this.fnGetEnvironmentRecord({
                        number: this.currentEnvironmentNew.number,
                        is_alarm: APP.YES,
                        create_at: this.searchDate ? this.searchDate.join(',') : '',
                        page: this.currentPage,
                        size: this.pageSize
                    },
                    res => {
                        this.tableData = res.query;
                        this.pageTotal = res.count;
                    }
                );
            },
            // 关闭当前组件
            fnClose() {
                this.$parent.fnOpenHome();
            },
            // 扬尘运行状态
            fnEnvrionmentStatusToText(_status) {
                return APP.fnCraneStatusToText(_status, 'environment');
            }
        }
    };
</script>
<style lang="scss" scoped>
    @import '@/styles/mixin.scss';

    .real_box {
        width: 1600px;
        height: 778px;
    }

    .search_box {
        height: 40px;
        width: 1600px;
        margin-bottom: 10px;
        @include flex-box(center, center);

        .box_line {
            width: 1580px;
            height: 32px;
            position: relative;
            @include flex-box(flex-start, center);

            .line_input {
                min-width: 280px;
                height: 30px;
                margin-right: 10px;
                border-top-right-radius: 1px;
                border-bottom-right-radius: 1px;
                background-color: rgba(49, 88, 128, 0.4);
                @include flex-box(flex-start, center);

                .input_title {
                    width: 69px;
                    height: 30px;
                    font-size: 14px;
                    color: #9bf9fc;
                    border-radius: 2px;
                    background-color: rgba(155, 249, 252, 0.1);
                    @include flex-box(center, center);
                }

                .input_box {
                    width: 211px;
                    height: 30px;
                    line-height: 30px;
                    padding-left: 15px;
                    color: rgba(77, 180, 244, 0.7);
                    font-size: 12px;
                    border-radius: 2px;
                    outline: none;
                    background: transparent;
                    border: none;

                    &::-webkit-input-placeholder {
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &::-moz-placeholder {
                        /* Mozilla Firefox 19+ */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-moz-placeholder {
                        /* Mozilla Firefox 4 to 18 */
                        color: rgba(77, 180, 244, 0.7);
                    }

                    &:-ms-input-placeholder {
                        /* Internet Explorer 10-11 */
                        color: rgba(77, 180, 244, 0.7);
                    }
                }
            }

            .title {
                position: absolute;
                right: 20px;
                @include flex-box(center, center);

                span {
                    color: #cf9236;
                    font-size: 24px;
                    margin-right: 20px;
                }
            }
        }
    }

    .cont_list {
        width: 1580px;
        margin: 0 10px;
        height: 660px;
        border-radius: 10px;
        background-color: rgba(29, 68, 149, 0.1);

        .list_title {
            width: 1580px;
            height: 48px;
            background: url(../../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                height: 48px;
                @include flex-box(center, center);

                &:nth-child(1) {
                    width: 106px;
                    margin: 0 4px 0 30px;
                }

                &:nth-child(2) {
                    width: 186px;
                    margin-right: 4px;
                }

                &:nth-child(3) {
                    width: 106px;
                    margin-right: 4px;
                }

                &:nth-child(4) {
                    width: 176px;
                    margin-right: 4px;
                }

                &:nth-child(5) {
                    width: 86px;
                    margin-right: 4px;
                }

                &:nth-child(6) {
                    width: 86px;
                    margin-right: 4px;
                }

                &:nth-child(7) {
                    width: 86px;
                    margin-right: 4px;
                }

                &:nth-child(8) {
                    width: 76px;
                    margin-right: 4px;
                }

                &:nth-child(9) {
                    width: 76px;
                    margin-right: 4px;
                }

                &:nth-child(10) {
                    width: 76px;
                    margin-right: 4px;
                }

                &:nth-child(11) {
                    width: 76px;
                    margin-right: 4px;
                }

                &:nth-child(12) {
                    width: 86px;
                    margin-right: 4px;
                }

                &:nth-child(13) {
                    width: 86px;
                    margin-right: 4px;
                }

                &:nth-child(14) {
                    width: 160px;
                    margin-right: 30px;
                }
            }
        }

        .list_boxes {
            width: 1520px;
            margin-left: 30px;
            height: 612px;
            position: relative;
            overflow: hidden;

            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .box_line {
                    width: 1520px;
                    height: 70px;
                    margin-top: 5px;
                    font-size: 16px;
                    color: #ffffff;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);

                    &:hover {
                        background-color: rgba(49, 88, 128, 0.4);
                    }

                    .list_item {
                        height: 70px;
                        @include flex-box(center, center);

                        &:nth-child(1) {
                            width: 106px;
                            margin-right: 4px;
                        }

                        &:nth-child(2) {
                            width: 186px;
                            margin-right: 4px;
                        }

                        &:nth-child(3) {
                            width: 106px;
                            margin-right: 4px;
                        }

                        &:nth-child(4) {
                            width: 176px;
                            margin-right: 4px;
                        }

                        &:nth-child(5) {
                            width: 86px;
                            margin-right: 4px;
                        }

                        &:nth-child(6) {
                            width: 86px;
                            margin-right: 4px;
                        }

                        &:nth-child(7) {
                            width: 86px;
                            margin-right: 4px;
                        }

                        &:nth-child(8) {
                            width: 76px;
                            margin-right: 4px;
                        }

                        &:nth-child(9) {
                            width: 76px;
                            margin-right: 4px;
                        }

                        &:nth-child(10) {
                            width: 76px;
                            margin-right: 4px;
                        }

                        &:nth-child(11) {
                            width: 76px;
                            margin-right: 4px;
                        }

                        &:nth-child(12) {
                            width: 86px;
                            margin-right: 4px;
                        }

                        &:nth-child(13) {
                            width: 86px;
                            margin-right: 4px;
                        }

                        &:nth-child(14) {
                            width: 160px;
                        }
                    }
                }
            }
        }
    }

    .cont_list_s {
        width: 1580px;
        margin: 0 10px;
        height: 660px;
        border-radius: 10px;
        background-color: rgba(29, 68, 149, 0.1);
        font-size: 13px;

        .list_title {
            width: 1580px;
            height: 48px;
            background: url(../../../../assets/img/per_list_bg.png) no-repeat;
            background-size: 100% 100%;
            @include flex-box(flex-start, center);

            .title_item {
                height: 48px;
                @include flex-box(center, center);

                &:nth-child(1) {
                    width: 80px;
                    margin: 0 3px 0 3px;
                }

                &:nth-child(2) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(3) {
                    width: 72px;
                    margin-right: 3px;
                }

                &:nth-child(4) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(5) {
                    width: 72px;
                    margin-right: 3px;
                }

                &:nth-child(6) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(7) {
                    width: 72px;
                    margin-right: 3px;
                }

                &:nth-child(8) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(9) {
                    width: 72px;
                    margin-right: 3px;
                }

                &:nth-child(10) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(11) {
                    width: 72px;
                    margin-right: 3px;
                }

                &:nth-child(12) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(13) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(14) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(15) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(16) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(17) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(18) {
                    width: 80px;
                    margin-right: 3px;
                }

                &:nth-child(19) {
                    width: 80px;
                    margin-right: 3px;
                }
            }
        }

        .list_boxes {
            width: 1580px;
            margin-left: 6px;
            height: 612px;
            position: relative;
            overflow: hidden;

            .list_box {
                position: absolute;
                left: 0;
                right: -25px;
                top: 0;
                bottom: 0;
                overflow-x: hidden;
                overflow-y: auto;

                .box_line {
                    width: 1520px;
                    height: 70px;
                    margin-top: 5px;
                    color: #ffffff;
                    border-bottom: 1px dashed #1d4495;
                    @include flex-box(flex-start, center);

                    &:hover {
                        background-color: rgba(49, 88, 128, 0.4);
                    }

                    .list_item {
                        height: 70px;
                        @include flex-box(center, center);

                        &:nth-child(1) {
                            width: 80px;
                            margin: 0 3px 0 3px;
                        }

                        &:nth-child(2) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(3) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(4) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(5) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(6) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(7) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(8) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(9) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(10) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(11) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(12) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(13) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(14) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(15) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(16) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(17) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(18) {
                            width: 80px;
                            margin-right: 3px;
                        }

                        &:nth-child(19) {
                            width: 80px;
                        }
                    }
                }
            }
        }
    }


    .cont_page {
        width: 1564px;
        height: 30px;
        margin-left: 21px;
        margin-top: 30px;

        >>>.el-pagination__total {
            color: #439fe3;
            font-size: 14px !important;
        }

        >>>.el-input__inner {
            background-color: rgba(49, 88, 128, 0.5) !important;
            border: none !important;
            color: #439fe3 !important;
        }

        >>>.el-pagination__jump {
            color: #439fe3;
            font-size: 14px !important;
        }

        >>>.el-select__caret {
            color: #439fe3;
        }

        >>>.el-pagination.is-background .btn-prev {
            color: #439fe3;
            background-color: rgba(49, 88, 128, 0.5) !important;
        }

        >>>.el-pagination.is-background .btn-prev:disabled {
            color: #439fe3;
            background-color: rgba(49, 88, 128, 0.5) !important;
        }

        >>>.el-pagination.is-background .btn-next {
            color: #439fe3;
            background-color: rgba(49, 88, 128, 0.5) !important;
        }

        >>>.el-pagination.is-background .btn-next:disabled {
            color: #439fe3;
            background-color: rgba(49, 88, 128, 0.5) !important;
        }

        >>>.el-pagination.is-background .el-pager li {
            color: #439fe3;
            background-color: rgba(49, 88, 128, 0.5) !important;
        }

        >>>.el-pagination.is-background .el-pager li:not(.disabled).active {
            background-color: #50aaff !important;
            color: #091027;
        }
    }

    .box_line {
        >>>.el-input__inner {
            width: 211px;
            height: 30px;
            border-radius: 2px;
            border: none;
            color: rgba(77, 180, 244, 0.7);
            background: transparent;

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

        >>>.el-input__icon {
            color: rgba(77, 180, 244, 0.7);
        }

        >>>.el-range-input {
            color: rgba(77, 180, 244, 0.7);
            background: transparent;

            &::-webkit-input-placeholder {
                color: rgba(77, 180, 244, 0.7);
            }

            &::-moz-placeholder {
                /* Mozilla Firefox 19+ */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-moz-placeholder {
                /* Mozilla Firefox 4 to 18 */
                color: rgba(77, 180, 244, 0.7);
            }

            &:-ms-input-placeholder {
                /* Internet Explorer 10-11 */
                color: rgba(77, 180, 244, 0.7);
            }
        }

        >>>.el-range-separator {
            color: rgba(77, 180, 244, 0.7);
        }
    }
</style>



// WEBPACK FOOTER //
// src/views/Environmental/environmentDefault/components/Alarm.vue